export const localization = {
  pt: {
    title: 'Atualizar URL',
    subtitle: 'Adicione uma nova URL para atualizar a base de conhecimento atual.',
    input: { placeholder: 'https://www.exemplo.com.br', requiredErrorMessage: 'O campo URL é obrigatório.' },
    cancelButton: 'Cancelar',
    saveButton: 'Atualizar',
    successToast: {
      title: 'Conteúdo atualizado',
      message: 'O conteúdo foi salvo e está disponível no catálogo.',
    },
    errorToast: {
      title: 'Falha ao atualizar o conteúdo',
      message: 'Não foi possível salvar o conteúdo. Tente novamente.',
    },
  },
  en: {
    title: 'Update URL',
    subtitle: 'Add a new URL to update the current knowledge base.',
    input: { placeholder: 'https://www.example.com', requiredErrorMessage: 'The URL field is required.' },
    cancelButton: 'Cancel',
    saveButton: 'Update',
    successToast: {
      title: 'Content Updated',
      message: 'The content has been saved and is now available in the catalog.',
    },
    errorToast: {
      title: 'Failed to Update Content',
      message: 'Unable to save the content. Please try again.',
    },
  },
  es: {
    title: 'Actualizar URL',
    subtitle: 'Agrega una nueva URL para actualizar la base de conocimiento actual.',
    input: { placeholder: 'https://www.ejemplo.com', requiredErrorMessage: 'El campo URL es obligatorio.' },
    cancelButton: 'Cancelar',
    saveButton: 'Actualizar',
    successToast: {
      title: 'Contenido actualizado',
      message: 'El contenido se ha guardado y está disponible en el catálogo.',
    },
    errorToast: {
      title: 'Fallo al actualizar el contenido',
      message: 'No se pudo guardar el contenido. Inténtalo de nuevo.',
    },
  },
};
